export default async ({ app }) => {
    await app.$recaptcha.init()
}
